import { MapRequestService } from './map-request.service';
import { IHttpMapGet } from './../interfaces/httpReq.interface';
import { I18NService } from '@ebw-monorepo/i18n-translate';
import { EbwModalService } from '@ebw-monorepo/modal';
import { IMapTable } from './../interfaces/mapTable.interface';
import { MapTableService } from './map-table.service';
import { Injectable } from '@angular/core';
import { SplitViewService } from '@ebw-monorepo/utils';
import { MapTableComponent } from '../components/map-table/map-table.component';
import { SplitViewConf } from 'libs/ng-components/utils/src/lib/models/split-view-conf';

@Injectable({
  providedIn: 'root'
})
export class QueryService {
  private _contextId = 'query_table';

  constructor(
    private mapTableSrv: MapTableService,
    private ebwModalSrv: EbwModalService,
    private i18nSrv: I18NService,
    private httpSrv: MapRequestService,
    private _splitViewService: SplitViewService
  ) {}

  queryExec(config: IMapTable) {
    if (config) {
      const splitViewConf: SplitViewConf = {
        title: config.title,
        icon: 'table_view'
      };
      this._splitViewService.show(MapTableComponent, this._contextId, null, splitViewConf);
      this.mapTableSrv.setMapTableConfig(config);
    } else {
      this.ebwModalSrv.openErrorModal({
        title: this.i18nSrv.getInstantValue('common.error'),
        content: this.i18nSrv.getInstantValue('common.data_retrieving_error')
      });
    }
  }

  deleteQuery(req: IHttpMapGet, body: any, name: string, callback?: Function) {
    const confirmModal = this.ebwModalSrv.openConfirmModal({
      title: this.i18nSrv.getInstantValue('common.delete_title'),
      content: this.i18nSrv.getTranslateParameter('common.delete_message', name)
    });

    confirmModal.afterClosed().subscribe((result) => {
      if (result == true) {
        this.httpSrv.postMapRequest(req, body).subscribe({
          next: (resp: any) => {
            if (resp) {
              const success = this.ebwModalSrv.openSuccessModal({
                title: this.i18nSrv.getInstantValue('common.delete_title'),
                content: this.i18nSrv.getInstantValue('common.delete_title')
              });
              success.afterClosed().subscribe(() => {
                if (callback) {
                  callback();
                }
              });
            }
          },
          error: (error) => {
            this.ebwModalSrv.openErrorModal({
              title: this.i18nSrv.getInstantValue('common.delete_title'),
              content: this.i18nSrv.getInstantValue('common.delete_error')
            });
          }
        });
      }
    });
  }
}
